import Navbar from "@/components/aevum/Navbar";
import Hero from "@/components/aevum/Hero";
import About from "@/components/aevum/About";
import Manifesto from "@/components/aevum/Manifesto";
import Newsletter from "@/components/aevum/Newsletter";
import Footer from "@/components/aevum/Footer";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="relative bg-[#050505] text-[#F5F2EA] font-body min-h-screen overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <About />
      <Manifesto />
      <Newsletter />
      <Footer />
    </main>
  );
}
